export const EPOCH_MINUTE = 60 * 1000;
export const EPOCH_HOUR = EPOCH_MINUTE * 60;
export const EPOCH_DAY = EPOCH_HOUR * 24;
export const EPOCH_WEEK = EPOCH_DAY * 7;
export const EPOCH_YEAR = EPOCH_DAY * 365;
